import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../button';
import useLayersStore from '../../stores/layersStore';
import { Pause, Play, ChevronDown } from 'react-feather'
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';

function AnimationButton() {
    const [isOpen, setIsOpen] = useState(true);
    const animationInfos = useLayersStore((state) => state.animationInfos);
    const currentAnimation = useLayersStore((state) => state.currentAnimation);
    const setCurrentAnimation = useLayersStore((state) => state.setCurrentAnimation);
    const lastSelectedAnimation = useLayersStore((state) => state.lastSelectedAnimation);
    const animations = useLayersStore((state) => state.animations);
    const featureEnabled = useLayersStore((state) => state.featureEnabled);

    const [titleFull, titleAbrv] = useMemo(() => {
        const titleItem = animationInfos?.find(item => item.name.includes('Title:'));
        if (titleItem) {
            const cleanTitle = titleItem.name.replace('Title:', '').replace(/Animations?/i, '').trim();
            return [cleanTitle + " Animations", cleanTitle + " Anims."];
        }
        return ['Animation', 'Anim.'];
    }, [animationInfos]);

    const filteredAnimationInfos = useMemo(() => 
        animationInfos?.filter(item => !item.name.includes('Title:')) || []
    , [animationInfos]);

    const isMultipleAnimations = useMemo(() => animationInfos?.length > 1, [animations]);

    if (!featureEnabled.play || (!animationInfos?.length && !animations?.length)) {
        return (<div className='w-[120px]'/>);
    }

    const handleTitleButtonClick = () => {
        if (isMultipleAnimations) {
            if (currentAnimation) {
                setCurrentAnimation(null);
                e.stopPropagation();
            } else {
                handleAnimationSelect(lastSelectedAnimation || filteredAnimationInfos[0]);
            }
        } else if (currentAnimation) {
            setCurrentAnimation(null);
            e.stopPropagation();
        } else {
            handleAnimationSelect(true)
        }
    };

    const handleAnimationSelect = (animation) => {
        if (currentAnimation === animation) {
            setCurrentAnimation(null);
        } else {
            setCurrentAnimation(animation);
        }
    };

    animationInfos?.forEach((item, index) => {
        console.log('DEBUG INFO -- Animation Info:', item);
    });

    return (
        <div className='z-50 pointer-events-auto cursor-pointer relative overflow-visible w-auto'>
            <Button className='flex flex-col' onClick={handleTitleButtonClick}>
                <div className='flex gap-1 items-center justify-between'>
                    {currentAnimation ? <Pause size={18} onClick={(e) => {
                        setCurrentAnimation(null);
                        e.stopPropagation();
                    }
                    } /> : <Play size={18} onClick={!isMultipleAnimations ? () => handleAnimationSelect(true) : undefined} />}
                    <div className='hidden sm:block'>{titleFull}</div>
                    <div className="sm:hidden">{titleAbrv}</div>
                    {isMultipleAnimations && (
                        <ChevronDown 
                            size={16} 
                            className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsOpen(!isOpen);
                            }}
                        />
                    )}
                </div>

                {isMultipleAnimations && <div 
                    className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-60' : 'max-h-0'}`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <PerfectScrollbar
                        options={{
                            suppressScrollX: true,
                            minScrollbarLength: 20
                        }}
                        style={{
                            maxHeight: '240px',
                            width: '100%'
                        }}
                    >
                        <div className="py-1">
                            {filteredAnimationInfos.map((item, index) => (
                                <div
                                    key={index}
                                    className={`px-0 py-2 border-t border-gray-200 w-full text-start hover:bg-gray-100 transition-colors duration-150 ${ item === lastSelectedAnimation ? "bg-blue-100 border-blue-300" : "" }`}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleAnimationSelect(item);
                                    }}
                                >
                                    {item.name}
                                </div>
                            ))}
                        </div>
                    </PerfectScrollbar>
                </div>}
            </Button>
        </div>
    );
}

export default AnimationButton; 
